import { Component, computed, type ElementRef, inject, input, viewChild } from '@angular/core';

import { FilteringService } from '../../services/filtering';
import { ContactForm } from '../contact-form/contact-form';
import { ContactFormType } from './contact-form-type';

export type ReasonForNoResults = 'general' | 'map' | 'model' | 'rep';

@Component({
  imports: [ContactForm],
  selector: 'app-no-results',
  styleUrl: './no-results.css',
  templateUrl: './no-results.html',
})
export class NoResults {
  protected readonly filteringService = inject(FilteringService);

  public readonly reason = input.required<ReasonForNoResults>();

  protected readonly suggestions = viewChild<ElementRef>('suggestionsTag');

  protected readonly formType = computed(() => ContactFormType.call(this));

  public navToSuggestions(): void {
    if (!this.suggestions()?.nativeElement) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- The `scrollIntoView` method is a standard DOM method and is safe to call on an element reference.
    this.suggestions()?.nativeElement.scrollIntoView({ behavior: 'smooth', container: 'all' });
  }
}
